import React from "react";
import { useAppContext } from "../../AppProvider";
import { useTrackingContext } from "./providers/Tracking";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "../../utilities/fontawesomeIcons";
import { Modal, ModalBody, ModalHeader, ModalFooter, FormGroup, Label } from "reactstrap";
import Event from "../Tracking/Event";
import ButtonUtility from "../../Components/Buttons/Utility";
import ButtonConfirm from "../../Components/Buttons/Confirm";
import SyncSelect from "../../Components/Selects/SyncSelect/SyncSelect";
import InputIcon from "../../Components/Inputs/InputIcon/InputIcon";

const Tracking: React.FC = () => {
  const { dictionary } = useAppContext();
  const {
    isOpen, data, loader, getData, shipment, retracking,
    manualEventOpen, manualEventData, manualEventLoader,
    openManualEvent, closeManualEvent, onChangeManualEvent, submitManualEvent,
    loadStatusCodes,
  } = useTrackingContext();

  return (
    <React.Fragment>
      {/* <CardHeader> */}
      <div
        className="cursor-pointer"
        onClick={() => {
          if (shipment.id) {
            getData(!isOpen);
          }
        }}
      >
        {shipment.id && (
          <div
            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center cursor-pointer"
            style={{
              zIndex: 10,
              borderRadius: "inherit",
            }}
          ></div>
        )}
      </div>
      {/* </CardHeader> */}

      <Modal isOpen={isOpen}>
        <ModalBody>
          {loader ? (
            <div className="text-center mt-2 ">
              <FontAwesomeIcon icon={faLoader} spin size="2x" />
            </div>
          ) : (
            <>
              {shipment.forceTrackingEnabled && (
                <div className="row mb-2">
                  <div className="col text-end d-flex gap-2 justify-content-end">
                    <ButtonUtility onClick={retracking}>
                      {dictionary.words.retracking}
                    </ButtonUtility>
                    <ButtonUtility onClick={openManualEvent}>
                      {dictionary.actions.add_tracking_event}
                    </ButtonUtility>
                  </div>
                </div>
              )}
              {data.map((elem, i) => {
                return (
                  <Event
                    key={i}
                    data={elem}
                    formatDate={"DD/MM/YYYY HH:mm"}
                    shipment={shipment}
                    isLastEvent={i === 0}
                  />
                );
              })}
              <div className="d-flex mt-3">
                <ButtonUtility
                  className="w-100"
                  onClick={() => getData(!isOpen)}
                  disabled={loader}
                >
                  {dictionary.actions.close}
                </ButtonUtility>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
      <Modal isOpen={manualEventOpen} toggle={closeManualEvent}>
        <ModalHeader toggle={closeManualEvent}>
          {dictionary.words.manual_tracking_event}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>{dictionary.dates.event_date} *</Label>
            <input
              type="datetime-local"
              className="form-control"
              value={manualEventData.eventDate}
              onChange={(e) => onChangeManualEvent("eventDate", e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>{dictionary.words.status}</Label>
            <SyncSelect
              name="statusCode"
              optionValue="code"
              optionLabel="name"
              value={manualEventData.status}
              onChange={(_name: string, value: any) =>
                onChangeManualEvent("status", value ?? null)
              }
              loadOptions={loadStatusCodes}
              isClearable
            />
          </FormGroup>
          <FormGroup>
            <Label>{dictionary.locations.location}</Label>
            <InputIcon
              name="location"
              value={manualEventData.location}
              onChange={(e) => onChangeManualEvent(e.target.name, e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>{dictionary.words.note}</Label>
            <InputIcon
              name="note"
              value={manualEventData.note}
              onChange={(e) => onChangeManualEvent(e.target.name, e.target.value)}
            />
          </FormGroup>
          <div className="d-flex gap-3">
            <FormGroup check>
              <input
                type="checkbox"
                className="form-check-input"
                id="manualEventStock"
                checked={manualEventData.stock}
                onChange={(e) => onChangeManualEvent("stock", e.target.checked)}
              />
              <Label check for="manualEventStock">Stock</Label>
            </FormGroup>
            <FormGroup check>
              <input
                type="checkbox"
                className="form-check-input"
                id="manualEventUtc"
                checked={manualEventData.utc}
                onChange={(e) => onChangeManualEvent("utc", e.target.checked)}
              />
              <Label check for="manualEventUtc">UTC</Label>
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonConfirm
            onClick={submitManualEvent}
            disabled={!manualEventData.eventDate || manualEventLoader}
            loading={manualEventLoader}
          >
            {dictionary.actions.save}
          </ButtonConfirm>
          <ButtonUtility onClick={closeManualEvent} disabled={manualEventLoader}>
            {dictionary.actions.close}
          </ButtonUtility>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default Tracking;
